import { render, staticRenderFns } from "./people-icon.vue?vue&type=template&id=fc4b2c6a&scoped=true&"
import script from "./people-icon.vue?vue&type=script&lang=js&"
export * from "./people-icon.vue?vue&type=script&lang=js&"
import style0 from "./people-icon.vue?vue&type=style&index=0&id=fc4b2c6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b2c6a",
  null
  
)

export default component.exports